import { render, staticRenderFns } from "./doorTodoor.vue?vue&type=template&id=3b109b80&"
import script from "./doorTodoor.vue?vue&type=script&lang=js&"
export * from "./doorTodoor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports